import { ICategory } from '@sitegen/common/types/faq';

export const toogleAll = (data: Array<ICategory>, isAllCollapsed: boolean) => {
    data.forEach(element => {
        (element.items || []).forEach(item => {
            item.isOpen = isAllCollapsed;
        });
    });

    return data;
};
